// How long a browser waits before reading the arXiv status frame again, and
// when it stops reading on its own.
//
// A conversion takes thirty to sixty seconds, so the first twenty are worth
// watching closely and the rest are not. Past the last window the visitor is
// waiting on something that went wrong, and reading on their behalf only spends
// requests on both sides — from there they ask by hand.
export const CLOSE_WATCH_UNTIL = 20000
export const SLOWER_WATCH_UNTIL = 60000
export const GIVE_UP_AFTER = 300000

// watched: milliseconds spent watching a paper still being generated. Time a
// hidden tab spent away is not part of it — nobody was waiting then.
export function nextRead(watched) {
  if (watched >= GIVE_UP_AFTER) return { action: "stop" }
  if (watched < CLOSE_WATCH_UNTIL) return { action: "read", delay: 2000 }
  if (watched < SLOWER_WATCH_UNTIL) return { action: "read", delay: 5000 }

  return { action: "read", delay: 10000 }
}
